import React from 'react';
import { Col, Dropdown, Input, MenuProps, Popover, Row, Tooltip } from 'antd';
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons';
import { useRecoilValue } from 'recoil';
import { uiSettingState } from "@/states/uiSetting";


interface DeviceLocationMenuProps {
  fetchData: () => Promise<void>;
  treeItemSelected: any;
  filteredItems: MenuProps['items'];
  open: boolean;
  handleOpenChange: (nextOpen: boolean, info: any) => void;
}

const DeviceLocationMenu: React.FC<DeviceLocationMenuProps> = ({
  fetchData,
  treeItemSelected,
  filteredItems,
  open,
  handleOpenChange
}) => {
  const uiSetting = useRecoilValue(uiSettingState);

  return (
    <Col span={24}>
      <Row className="h5-semiBold">Device Locations</Row>
      <Tooltip className="reset-btn" title="Reset Filter">
        <ReloadOutlined onClick={fetchData} />
      </Tooltip>
      <Popover
        content={<Input.Search style={{ width: '250px' }} />}
        placement="top"
        title="Filter location/merchant"
        className="filter-popover"
        trigger="click"
      >
        <i className="filter-ic icon-filter-3" />
      </Popover>
      {((!treeItemSelected || (treeItemSelected && treeItemSelected.deviceFilterType !== 2)) && uiSetting?.isAllowAddDevice) && (
        <Tooltip className="add-btn" title="">
          <Dropdown menu={{ items: filteredItems }} placement="bottom" trigger={['click']} open={open} onOpenChange={handleOpenChange}>
            <PlusOutlined />
          </Dropdown>
        </Tooltip>
      )}
    </Col>
  );
};

export default DeviceLocationMenu;
